import ApiService from "@/services/api.service"

/// *** Documents Service *** ///

export const DocumentsService = {
  getDocumentTemplate(type, custom_id = null) {
    return ApiService.get(`document/${type}/template`, { custom_id: custom_id })
  },
  saveDocumentTemplate(type, text, custom_id = null) {
    return ApiService.post(`document/${type}/template`, { text26: text, custom_id: custom_id })
  },
  getAgreementsList(type) {
    return ApiService.get(`agreements/list`, { type: type })
  },
  getGeneratedDocuments(clientId, visitId) {
    return ApiService.get(`document/client/${clientId}/generated?visitId=${visitId}`)
  },
  generateDocument(clientId, doc, visitId) {
    return ApiService.post(`document/client/${clientId}/generate`, { doc, visitId })
  },
  signGeneratedDocument(clientId, documentId) {
    return ApiService.post(`document/client/${clientId}/generated/${documentId}/sign`)
  },
  signGeneratedDocumentViaTrustMe(clientId, documentId) {
    return ApiService.post(`document/client/${clientId}/generated/${documentId}/sign/trustme`)
  },
  signGeneratedDocumentViaEsia(clientId, documentId) {
    return ApiService.post(`document/client/${clientId}/generated/${documentId}/sign/esia`)
  },
  refreshStatusViaEsia(clientId, documentId) {
    return ApiService.post(`document/client/${clientId}/generated/${documentId}/refresh/esia`)
  },
  signGeneratedDocumentViaOnlineContractContract(clientId, documentId) {
    return ApiService.post(`document/client/${clientId}/generated/${documentId}/sign/onlinecontract/contract`, {}, {}, { loader: false })
  },
  signGeneratedDocumentViaOnlineContractPatient(clientId, documentId) {
    return ApiService.post(`document/client/${clientId}/generated/${documentId}/sign/onlinecontract/patient`, {}, {}, { loader: false })
  },
  signGeneratedDocumentViaOnlineContractParticipantToSign(clientId, documentId, participantId) {
    return ApiService.post(`document/client/${clientId}/generated/${documentId}/sign/onlinecontract/participant/send`, { participantId }, {}, { loader: false })
  },
  getOnlineContractSignatures(clientId, documentId) {
    return ApiService.get(`document/client/${clientId}/generated/${documentId}/onlinecontract/signatures`, {}, { loader: false })
  },
  getOnlineContractData(clientId, documentId) {
    return ApiService.get(`document/client/${clientId}/generated/${documentId}/onlinecontract/document`, {}, { loader: false })
  },
  uploadToGeneratedDocument(clientId, params) {
    return ApiService.post(`document/client/${clientId}/generated/upload`, params)
  },
  setTrustMeHook() {
    return ApiService.post(`trustme/hook/set`)
  },
  registerInOnlineContractKz({ email, password, username, token, type }) {
    return ApiService.post(`onlineContractKz/register`, { email, password, username, token, type })
  },
  resetOnlineContractKz() {
    return ApiService.delete(`onlineContractKz/reset`)
  },
  updateOnlineContractKzCompany(data) {
    return ApiService.post(`onlineContractKz/company/update`, data)
  },
  updateOnlineContractKzEmployee(data) {
    return ApiService.post(`onlineContractKz/employee/update`, data)
  },
  getOnlineContractKzContractPdf(docId) {
    return ApiService.post(`onlineContractKz/document/pdf`, { docId }, { responseType: "blob", })
  },
  getOnlineContractKzData() {
    return ApiService.get(`onlineContractKz/client`)
  },
  getVerificationLink() {
    return ApiService.get(`onlineContractKz/verificationLink`)
  },
  getOnlineContractOrders(page = 1) {
    return ApiService.get(`onlineContractKz/orders?page=${page}`)
  },
  getOnlineContractOrderLink(orderId, pdf = 0) {
    return ApiService.get(`onlineContractKz/orders/${orderId}/link?pdf=${pdf}`)
  },
  createOnlineContractOrder(data) {
    return ApiService.post(`onlineContractKz/orders`, data)
  },
  sendForSignToFDoc(docId) {
    return ApiService.post(`fdoc/sign/${docId}`)
  },
  checkFDocDocumentStatus(docId) {
    return ApiService.post(`fdoc/check/status/${docId}`)
  },
  sendMultipleForSignToFDoc(docIds) {
    return ApiService.post(`fdoc/sign/multiple/docs`, { docIds })
  },
  loadFDoc(docId) {
    return ApiService.post(`fdoc/load/${docId}`)
  },
  connectFDoc() {
    return ApiService.post(`fdoc/connect`)
  }
}
